var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "label",
      {
        staticClass: "control-label",
        class: [
          { "sr-only": _vm.hideLabel },
          { "text-danger": _vm.hasErrors },
          { "col-md-2": _vm.column },
        ],
        attrs: { for: _vm.forId },
      },
      [_vm._v(_vm._s(_vm.label))]
    ),
    _vm._v(" "),
    _vm.helpButton
      ? _c("sup", [
          _c("a", { attrs: { role: "button" }, on: { click: _vm.showHelp } }, [
            _c("i", { staticClass: "fa fa-question-circle" }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _vm.helpText
        ? _c("small", [_c("em", [_vm._v(_vm._s(_vm.helpText))])])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: ["field-area", { "alert alert-danger": _vm.hasErrors }] },
      [
        _vm._t("default"),
        _vm._v(" "),
        _vm.hasErrors
          ? _c("p", { staticClass: "text-danger" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.displayError) + "\n        "
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }